var exports = {
  "az": "Box__Ar9XKO",
  "mp": "feedback__31ktOr",
  "dF": "feedbackIcon__Rtd6b2",
};

module.exports = exports;
